export class View {
}
